import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const SuggestedPage = React.lazy(() => import('.'));

export const suggestedConfigs = [
  {
    permittedRole: [RoutePermittedRole.ADMIN, RoutePermittedRole.SUPERADMIN],
    path: '/suggested',
    element: <SuggestedPage />,
  },
];
